import { IPreciseFiltersState } from '../../types/redux/preciseFilters';
import { TReduxActions } from '../../types/redux';
import { EActionTypes } from '../../actions/preciseFilters';

export const initialState: IPreciseFiltersState = {
  data: {
    isFetching: false,
    isError: false,
    sale: null,
    rent: null,
  },
  ui: {},
};

export const preciseFiltersReducer = (state = initialState, action: TReduxActions): IPreciseFiltersState => {
  switch (action.type) {
    case EActionTypes.SetState: {
      return {
        ...state,
        ui: action.payload,
      };
    }

    case EActionTypes.Request: {
      return {
        ...state,
        data: {
          ...state.data,
          isFetching: true,
        },
      };
    }

    case EActionTypes.Success: {
      return {
        ...state,
        data: {
          ...state.data,
          isFetching: false,
          isError: false,
          [action.payload.dealType]: action.payload.data,
        },
      };
    }

    case EActionTypes.Failure: {
      return {
        ...state,
        data: {
          ...state.data,
          isFetching: false,
          isError: true,
        },
      };
    }

    default:
      return state;
  }
};
